import React from "react";
import ReactApexCharts from "react-apexcharts";
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";

function DevicetrendChart(props) {
  console.log("props.params", props);
  const formatter = new Intl.NumberFormat("en-US", {
    minimumFractionDigits: 3,
    maximumFractionDigits: 3,
  });
  const data = props.data;
  const text = props.param;
  const dev_id = data.map((_i) => _i.ssid);
  const name = data.map((_i) => _i.name);
  let tempArr = [];
  console.log("data33333333333333333333333333333333", data);
  data.map((obj) => {
    let tempData = {};
    const actual = parseFloat(obj.actual);
    tempData.x = obj.name.includes("-") ? obj.name.split("-")[1] : obj.name;

    if (props.param === "TFA_Duct_Temp_Monitor") {
      tempData.y =
        actual < 0 ? "0" : actual > 100 ? "100" : formatter.format(actual);
    } else {
      tempData.y = formatter.format(actual);
    }

    console.log("tempData ✅", tempData);
    tempArr.push(tempData);
    return tempArr;
  });

  const onclickchart = (e, c, con) => {
    if (props.eqp == "ahu") {
      let i = con.dataPointIndex;
      localStorage.setItem("deviceID", "Ahu2");
      localStorage.setItem("deviceName", "Ahu1");
      props.history.push({
        pathname: `/admin/glAhu`,
        state: {
          data: dev_id[i],
          name: name[i],
        },
      });
    } else {
      let i = con.dataPointIndex;
      // localStorage.setItem("deviceID", "Ahu2");
      // localStorage.setItem("deviceName", "Ahu1");
      props.history.push({
        pathname: `/admin/glCsu`,
        state: {
          data: dev_id[i],
          name: name[i],
        },
      });
    }
  };
  // console.log("tempArr--------->",tempArr)
  const dataset = {
    series: [
      {
        name: "Actual",
        data: tempArr,
      },
    ],
    options: {
      title: {
        text:
          text === "TFA_Duct_Temp_Monitor"
            ? "Duct Temp Monitor"
            : text === "TFA_VFD_Speed_Cntrl"
            ? "VFD Speed Control"
            : text == "TFA_CHW_Mtr_Vlv_Mod"
            ? "CHW Mtr Valve Modulation"
            : text == "CSU_Duct_pre"
            ? "Duct Pressure"
            : text == "CSU_RAT"
            ? "Return Air Temperature"
            : "ChW Valve Position",
      },

      chart: {
        type: "bar",
        height: 350,
        toolbar: {
          show: false, // ✅ disables pan/zoom/reset UI
        },
        zoom: {
          enabled: false, // ✅ disables zooming
        },
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: "25%",
          endingShape: "rounded",
        },
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        show: true,
        width: 2,
        colors: ["transparent"],
      },
      fill: {
        opacity: 1,
      },
      colors: ["#00E396"],
      tooltip: {
        y: {
          formatter: function (val) {
            return val;
          },
        },
      },
      yaxis: {
        title: {
          text:
            text == "TFA_CHW_Mtr_Vlv_Mod"
              ? "%"
              : text == "TFA_VFD_Speed_Cntrl"
              ? "%"
              : "℃",
        },
        decimalsInFloat: 2,
        labels: {
          formatter: function (val) {
            return val;
          },
        },
      },
    },
  };

  return (
    <div>
      <GridContainer>
        <GridItem>
          <ReactApexCharts
            options={dataset.options}
            series={dataset.series}
            type="bar"
            height={"163vh"}
          />
        </GridItem>
      </GridContainer>
    </div>
  );
}

export default DevicetrendChart;
